<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('people_podra')"
          :directory="[$t('contacts'), $t('people')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_person") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-person-modal
      v-if="isPersonModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @openOrgModal="openOrganizationModal"
      @close-modal="closeModal"
    />
    <app-contact-type-modal
      v-if="isContactModalActive"
      :table-id="contacttableId"
      @close-modal="closeContactModal"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="person-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <app-organization-modal
      v-if="organizationModal"
      :table-id="'organization-modal'"
      @close-modal="closeOrgModal"
    />

    <app-person-quick-view
      v-if="isQuickViewModalActive"
      dal-id="quickViewModal"
      :selected-url="selectedUrl"
      @openActivityModal="commonActivityModal"
      @viewAllDeal="openViewAllDeal"
      @viewAllFollower="openViewAllFollower"
      @editNote="editNote"
      @close-modal="closeQuickViewModal"
    />

  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { formatDateToLocal, collection, urlGenerator } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, organization, tag } from "@app/Mixins/Global/FilterMixins";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Person",
  extends: CoreLibrary,
  mixins: [owner,  organization, tag, getCustomFileds, DeleteMixin],
  data() {
    return {
	  formatDateToLocal,
      urlGenerator,
      isPersonModalActive: false,
      isContactModalActive: false,
      tableId: "person-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      personActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      personId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      commonColumn: [
        {
          title: this.$t("name"),
          type: "link",
          key: "name",
          modifier: (value, row) => {
            return `crm/persons/${row.id}/edit`;
          },
        },
		
		
	
        {
          title: this.$t("lead_groups"),
          type: "custom-html",
          key: "contact_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${
                  value.name
                }</span>`
              : "-";
          },
        },
        {
          title: this.$t("organization"),
          type: "custom-html",
          key: "organizations",
          modifier: function (organizations) {
            let organizationsList = organizations.length
              ? collection(organizations).get("name", "id")
              : [];
            let returnResult = ``;
            organizationsList.map((el, index) => {
              if (index < 2) {
                let orgDetailsUrl = urlGenerator(`crm/organizations/${el.id}/edit`);
                returnResult += `
                            <a class="mb-1 d-flex" href="${orgDetailsUrl}" target="_blank">
                            <span class="link-list">${el.name}</span>
                            <span class="text-muted mt-1">
                            <i
                                data-feather="external-link"
                            /></i>
                            </span>
                            </a>
                            `;
              }
            });
            if (organizationsList.length > 2) {
              let moreCount = organizationsList.length - 2;
              returnResult += `<small><b>+${moreCount} more</b><small>`;
            }
            return organizationsList.length ? returnResult : "-";
          },
        },
        
       
       
        {
          title: this.$t("owner"),
          type: "object",
          key: "owner",
          modifier: (value, row) => {
            return value ? value.full_name : "";
          },
        },
        {
          title: this.$t("tags"),
          type: "component",
          key: "tags",
          isVisible: true,
          componentName: "tags-type-column",
        },

		{
          title: this.$t("created_at"),
          type: "custom-html",
          key: "created_at",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.created_at)}</span>`
              : "-";
          },
        },
		
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("person_table"),
        url: "crm/persons?podra",
        showHeader: true,
        countView: true,
        columns: [],
        filters: [
          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
    
          
          {
            title: this.$t("organization"),
            type: "multi-select-filter",
            key: "organization",
            option: [],
          },
          {
            title: this.$t("tag"),
            type: "multi-select-filter",
            key: "tags",
            option: [],
          },
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-person-quick-view",
            modalId: "quickViewModal",
            url: "",
          },
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-person-modal",
            modalId: "person-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "person-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/persons/${rowData.id}`;
        this.isPersonModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/persons/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("quick_view")) {
        this.selectedUrl = `crm/person/navigation-change/${rowData.id + 1}?parm=previous`;
        this.isQuickViewModalActive = true;
      }
    },
    openModal() {
      this.isPersonModalActive = true;
    },
    openContactModal() {
      this.isContactModalActive = true;
    },
    closeContactModal() {
      this.isContactModalActive = false;
      this.selectedUrl = "";
      $("#contact-type-modal").modal("hide");
    },
    closeModal() {
      this.isPersonModalActive = false;
      this.selectedUrl = "";
      $("#person-modal").modal("hide");
    },
    closeQuickViewModal() {
      this.isQuickViewModalActive = false;
      this.selectedUrl = "";
      $("#quickViewModal").modal("hide");
    },
    
    
    openOrganizationModal() {
      this.organizationModal = true;
      setTimeout(() => {
        $("#person-modal").css({
          //"backdrop-filter": "blur(4px)"
          opacity: "0.5",
        });
      });
    },
    closeOrgModal() {
      this.$store.dispatch("getOrganization");
      $("#organization-modal").modal("hide");
      this.organizationModal = false;
      $("#person-modal").css({
        opacity: "1",
        //"backdrop-filter": "blur(0px)"
      });
    },
  },
  computed: {
    ...mapGetters({
      organizationList: "getOrganization",
    }),
  },
  mounted() {
    this.getCustomFiled("person");
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
